import { Request, Response, NextFunction } from "express";
import os from "os";

const hostname = os.hostname();

export const log = (output: string) => {
	if (hostname === "office") {
		console.log(output);
	}
};

export default function (req: Request, res: Response, next: NextFunction) {
	if (hostname === "office") {
		console.log("\n");
		console.log(req.method, req.baseUrl);

		if (Object.keys(req.params || {}).length > 0) {
			console.log(">> PARAMS:", req.params);
		}
		if (Object.keys(req.query).length > 0) {
			console.log(">> QUERY:", req.query);
		}
		if (Object.keys(req.body).length > 0) {
			console.log(">> BODY:", req.body);
		}
	}

	next();
}
